import { render, staticRenderFns } from "./changeAdd.vue?vue&type=template&id=25af3d1e&scoped=true&"
import script from "./changeAdd.vue?vue&type=script&lang=js&"
export * from "./changeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af3d1e",
  null
  
)

export default component.exports